// import { ArtifactsReducerAction } from "../interfaces";
import { Action } from "redux";
import * as types from "../consts";

const initState = {
  isArtifactsOk: false,
  artifactsRes: {},
};

export default function historyArtifactsReducer(
  state = initState,
  action: Action
) {
  switch (action.type) {
    case types.GET_ARTIFACTS_REQUEST:
      return {
        ...state,
        isArtifactsOk: false,
      };
    case types.GET_ARTIFACTS_SUCCESS:
      return {
        ...state,
        isArtifactsOk: true,
        artifactsRes: action,
      };
    case types.GET_ARTIFACTS_ERROR:
      return {
        ...state,
        isArtifactsOk: false,
      };
    default:
      return { ...state };
  }
}
